// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"94":"Login","138":"profile","594":"demo"}[chunkId] || chunkId) + "-legacy." + {"94":"1dd852fb","138":"f806cbe5","594":"631ce8d9","827":"7410a44a"}[chunkId] + ".js";
};